// eslint-disable-next-line import/prefer-default-export
export const observationStatuses = {
  archived: { label: 'Archived', value: 'archived' },
  complete: { label: 'Completed', value: 'complete' },
  in_progress: { label: 'In Progress', value: 'in_progress' },
  in_review: { label: 'In Review', value: 'in_review' },
  new: { label: 'New', value: 'new' },
  on_hold: { label: 'On Hold', value: 'on_hold' },
};

export const observationColors = {
  archived: '#CCCCCC',
  complete: '#999999',
  in_progress: '#E2A74F',
  in_review: '#8A50D1',
  new: '#4CAF50',
  on_hold: '#FFDD67',
};

export const MODALITY_OPTIONS_LABELS = {
  bone_densitometry: 'Bone Densitometry',
  ct: 'CT',
  fluoroscopy: 'Fluoroscopy',
  mammography: 'Mammography',
  mri: 'MRI',
  nuclear_medicine: 'Nuclear Medicine',
  us: 'US',
  xray: 'X-ray/Radiography',
};

export const MODALITY_OPTIONS = [
  { label: 'Bone Densitometry', value: 'bone_densitometry' },
  { label: 'CT', value: 'ct' },
  { label: 'Fluoroscopy', value: 'fluoroscopy' },
  { label: 'Mammography', value: 'mammography' },
  { label: 'MRI', value: 'mri' },
  { label: 'Nuclear Medicine', value: 'nuclear_medicine' },
  { label: 'US', value: 'us' },
  { label: 'X-ray/Radiography', value: 'xray' },
];

export const MODALITY_ABBREVIATIONS = {
  bone_densitometry: 'BD',
  ct: 'CT',
  fluoroscopy: 'FL',
  mammography: 'MG',
  mri: 'MRI',
  nuclear_medicine: 'NM',
  us: 'US',
  xray: 'XR',
};

export const TIME_PERIOD_VALUES = {
  CUSTOM: 'custom',
  ONE_MONTH: 'one_month',
  ONE_WEEK: 'one_week',
  ONE_YEAR: 'one_year',
  THIS_YEAR: 'this_year',
};

export const TIME_PERIOD_LABELS = {
  [TIME_PERIOD_VALUES.ONE_WEEK]: '1 Week',
  [TIME_PERIOD_VALUES.ONE_MONTH]: '1 Month',
  [TIME_PERIOD_VALUES.THIS_YEAR]: 'This Year',
  [TIME_PERIOD_VALUES.ONE_YEAR]: '1 Year',
  [TIME_PERIOD_VALUES.CUSTOM]: 'Custom',
};

export const GRANULARITY_VALUES = {
  DAILY: 'daily',
  MONTHLY: 'monthly',
  WEEKLY: 'weekly',
  YEARLY: 'yearly',
};

export const TYPE_OPTIONS_ENUM = {
  CALL_BACK: 'call_back',
  ROUTINE: 'routine',
  STAT: 'stat',
  URGENT: 'urgent',
};

export const TYPE_OPTIONS = [
  { label: 'Call Back', value: TYPE_OPTIONS_ENUM.CALL_BACK },
  { label: 'Routine', value: TYPE_OPTIONS_ENUM.ROUTINE },
  { label: 'STAT', value: TYPE_OPTIONS_ENUM.STAT },
];

export const STATUS_OPTIONS = [
  { label: 'New', value: 'new' },
  { label: 'In Progress', value: 'in_progress' },
  { label: 'In Review', value: 'in_review' },
  { label: 'On Hold', value: 'on_hold' },
  { label: 'Complete', value: 'complete' },
];
